import { render, staticRenderFns } from "./pages9.vue?vue&type=template&id=1d833bab&"
import script from "./pages9.vue?vue&type=script&lang=js&"
export * from "./pages9.vue?vue&type=script&lang=js&"
import style0 from "./pages9.vue?vue&type=style&index=0&id=1d833bab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports